import { defineComponent } from "@vue/composition-api";
import usePromotedUsers from "@/views/PagePromotedUsers/hooks/usePromotedUsers";

export default defineComponent({
  name: "usersNewController",
  setup() {
    const { render, getFirstPage } = usePromotedUsers({
      isNew: true,
    });
    getFirstPage();
    return render;
  },
});
